import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from '@shared/components/button/button';
import { ModalService } from '@shared/components/modal/modal.service';
import { ProjectContextStore } from '@core/project-context/project-context.store';
import { ProjectSelectorModal } from './project-selector-modal';

/**
 * The active project at the top of the sidebar, with the Change button that
 * opens `ProjectSelectorModal`. The switch itself happens in the modal.
 */
@Component({
  selector: 'app-project-selector',
  imports: [TranslatePipe, Button],
  templateUrl: './project-selector.html',
  styleUrl: './project-selector.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSelector {
  private readonly projectContextStore = inject(ProjectContextStore);
  private readonly modal = inject(ModalService);

  /** The sidebar's drawer; absent when the selector renders outside the shell. */
  private readonly sidenav = inject(MatSidenav, { optional: true });

  protected readonly activeProject = this.projectContextStore.activeProject;

  protected openSelector(): void {
    // Treated like any other menu entry: when the drawer is floating over the
    // page (phones), it slides away rather than stay open behind the modal.
    if (this.sidenav?.mode === 'over') {
      void this.sidenav.close();
    }

    this.modal.open(ProjectSelectorModal);
  }
}
